import styled from 'styled-components'

import { Button, CloseIcon } from '@blade/ui-kit'
import { useTranslation } from '@root/shared/localization'

type Props = { onOpenChange?: (open: boolean) => void }

export const PortWalletsDrawerHeader: React.FC<Props> = ({ onOpenChange }) => {
  const { t } = useTranslation()

  return (
    <Root>
      <Title>{t('wallet-tracker.port.title')}</Title>
      <Button
        variant="ghost"
        type="button"
        iconLeft={<CloseIcon />}
        onClick={() => onOpenChange?.(false)}
        size="xs"
      />
    </Root>
  )
}

const Root = styled.div`
  border-bottom: 1px solid var(--background-3);

  display: grid;
  grid-template-columns: minmax(0, 1fr) auto;
  align-items: center;
  padding: 14px 0 10px;
  margin-inline: 14px;
`

const Title = styled.div`
  color: var(--text-11);

  display: flex;
  align-items: center;

  gap: 6px;
  font-size: 14px;
  font-weight: 600;
  line-height: 20px;
`
